import React from 'react' 

const Resources = () => {
    return (
        <div className="container">
            <br/>
            <br/>
            <br/>
            <br/>
        <h1 className="center">Resources 🌟</h1>            
        <p className="center-note-resources">
        Some of the links mentioned are affiliate links, so I may get a commission after purchasing (at no extra cost to you). These funds help me make better content for y'all! 
        </p>

        <h2 className="center">Products I stan 🛍</h2>  

        <div class="columns-resources">
        <div class="column-resources">
        <img className = "resources-pic" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/image%2058.png"></img>
        <p>
        <a
        className="peoplelinks"
        href="https://amzn.to/3GMr7XF"
        ><i><b>Rich Dad Poor Dad</b></i></a>
            <br/>
            The book that changed my life
        </p>        </div>
        <div class="column-resources">
        <img className = "resources-pic" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/image%2059.png"></img>
        <p>
        <a
        className="peoplelinks"
        href="https://amzn.to/3Jq2dis"
        ><i><b>RESPAWN Gaming Chair</b></i></a>            
        <br/>
            Most comfortable chair ever
        </p>        
        </div>
        <div class="column-resources">
        <img className = "resources-pic" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/image%2060.png"></img>
        <p>
        <a
        className="peoplelinks"
        href="https://amzn.to/3Bqjy8c"
        ><i><b>67" Camera Tripod Stand, Torjim</b></i></a>     
            <br/>
            The tripod I use for filming
        </p>
        </div>
        </div>
<br/>
        <div class="columns-resources">
        <div class="column-resources">
        <img className = "resources-pic" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/image%2058%20(1).png"></img>
        <p>
        <a
        className="peoplelinks"
        href="https://amzn.to/3uJ7yxf"
        ><i><b>Oculus Quest 2 – 128 GB</b></i></a>
            <br/>
            VR Headset that helps me exercise
        </p>        </div>
        <div class="column-resources">
        <img className = "resources-pic" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/image%2059%20(1).png"></img>
        <p>
        <a
        className="peoplelinks"
        href="https://amzn.to/3Jq2dis"
        ><i><b>DUCHY Laptop Stand</b></i></a>            
        <br/>
            Ergonomic & portable lifesaver
        </p>        
        </div>
        <div class="column-resources">
        <img className = "resources-pic" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/image%2060%20(1).png"></img>
        <p>
        <a
        className="peoplelinks"
        href="https://amzn.to/3Bqjy8c"
        ><i><b>Wallniture Lamba LED Lights</b></i></a>     
            <br/>
            For that crisp video lighting
        </p>
        </div>
        </div>

<br/>

        <h2 className="center">Apps I love 📲</h2>     

         <div class="columns-resources">
        <div class="column-resources">
        <img className = "resources-pic" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/Group%208.png"></img>
        <p>
        <a
        className="peoplelinks"
        href="https://figma.com"
        ><i>Figma</i></a>
            <br/>
            UI Design and Prototyping
        </p>        </div>
        <div class="column-resources">
        <img className = "resources-pic" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/Group%207.png"></img>
        <p>
        <a
        className="peoplelinks"
        href="https://code.visualstudio.com/"
        ><i>Visual Studio Code</i></a>            
        <br/>
        Coding IDE by Microsoft
        </p>        
        </div>
        <div class="column-resources">
        <img className = "resources-pic" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/image%2058%20(2).png"></img>
        <p>
        <a
        className="peoplelinks"
        href="https://sparkar.facebook.com/ar-studio/download/"
        ><i>Spark AR Studio</i></a>     
            <br/>
            Make AR filters for Instagram
        </p>
        </div>
        </div>

<br/>
         <div class="columns-resources">
        <div class="column-resources">
        <img className = "resources-pic" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/image%2058%20(3).png"></img>
        <p>
        <a
        className="peoplelinks"
        href="https://canva.com"
        ><i>Canva</i></a>
            <br/>
            Social media posts & decks
        </p>        </div>
        <div class="column-resources">
        <img className = "resources-pic" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/image%2060%20(2).png"></img>
        <p>
        <a
        className="peoplelinks"
        href="https://share.epidemicsound.com/bqsx3j"
        ><i>Epidemic Sound</i></a>            
        <br/>
        Non-Copyrighted music library
        </p>        
        </div>
        <div class="column-resources">
        <img className = "resources-pic" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/image%2059%20(2).png"></img>
        <p>
        <a
        className="peoplelinks"
        href="https://www.apple.com/final-cut-pro/"
        ><i>Final Cut Pro X</i></a>     
            <br/>
            Video editing software
        </p>
        </div>
        </div>       
        
        </div>
    )
}

export default Resources
